import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, change } from 'redux-form';
import { withRouter } from 'react-router';
import v from 'validate.js';
import styles from './style.module.css';
import * as Routes from '../../../../../constants/routes';
import { formatMortgageTerm } from '../../../../../helpers/mortgage';
import { trackingEvent } from '../../../../../helpers/tracking';
import { onSubmit } from '../../../../../common/components/submit-button';
import RenderSelect from '../../../../../common/components/render-input/select';
import logger from '../../../../../helpers/logger';

export const formName = Routes.STEPSEVEN;

const tracking = {
    eventAction: 'Mortgage Calculator - Step 7',
    eventLabel: 'Your Mortgage Rate'
};

const validate = values => v(values, {
    mortgageTerm: {
        presence: {
            allowEmpty: false,
            message: 'is required'
        }
    }
});

const defaultMortgageTerm = formatMortgageTerm('5 Year Closed', 'Fixed Rate');

class StepSevenForm extends Component {
    componentDidMount() {
        const {
            props: {
                changeFieldValue,
                mortgageTerms = [],
                initialValues: {
                    mortgageTerm
                }
            }
        } = this;

        const defaultValue = mortgageTerms.find(({ Range, SubType }) => formatMortgageTerm(Range, SubType) === mortgageTerm);

        if (!defaultValue && mortgageTerms.length > 0) {
            const selectedTerm = formatMortgageTerm(mortgageTerms[0].Range, mortgageTerms[0].SubType);
            changeFieldValue('mortgageTerm', selectedTerm);
        }
    }

    componentDidUpdate(prevProps) {
        // Log validation errors
        if (this.props.invalid && this.props.submitFailed && this.props.syncErrors) {
            logger.warn('Form validation failed in Step 7', {
                step: 7,
                formName: formName,
                errors: this.props.syncErrors,
                values: this.props.values
            });
        }

        // Log mortgage term selection changes
        if (prevProps.selectedTerm !== this.props.selectedTerm) {
            logger.logUserAction('mortgage_term_changed', 'MortgageCalculator-Step7', {
                step: 7,
                previousTerm: prevProps.selectedTerm,
                selectedTerm: this.props.selectedTerm,
                termMonths: this.props.selectedTerm.NumOfMonth ? this.props.selectedTerm.NumOfMonth : null
            });
        }

        const {
            props: {
                changeFieldValue,
                selectedTerm = {}
            }
        } = this;

        changeFieldValue('mortgageTermMonths', selectedTerm.NumOfMonth);
    }

    render() {
        const {
            props: {
                mortgageTerms = []
            }
        } = this;

        const mortgageTermOptions = mortgageTerms
            .reduce((terms, { Range, SubType }) => ({
                ...terms,
                [formatMortgageTerm(Range, SubType)]: formatMortgageTerm(Range, SubType)
            }), {});

        return (
            <form className={styles.form}>
                <Field
                    name='mortgageTerm'
                    label='The time you are committed to this mortgage'
                    options={mortgageTermOptions}
                    component={RenderSelect}
                    onChange={(event, newValue, previousValue) => {
                        if (newValue !== previousValue) {
                            logger.logUserAction('mortgage_term_dropdown_changed', 'MortgageCalculator-Step7', {
                                step: 7,
                                field: 'mortgageTerm',
                                previousValue,
                                newValue,
                                availableOptions: Object.keys(mortgageTermOptions).length
                            });
                        }
                    }}
                />
            </form>
        );
    }
}

const selector = formValueSelector(formName);

const mapStateToProps = (state) => ({
    initialValues: {
        mortgageTerm: defaultMortgageTerm
    },
    mortgageTerms: state.mortgage.terms,
    selectedTerm: state.mortgage.terms ? state.mortgage.terms.find(({ Range, SubType }) => formatMortgageTerm(Range, SubType) === selector(state, 'mortgageTerm')) : {}
});

const mapDispatchToProps = dispatch => ({
    changeFieldValue: (field, value) => dispatch(change(formName, field, value))
});

// Enhanced onSubmit with logging
const enhancedOnSubmit = async (values, dispatch, props) => {
    try {
        const result = await onSubmit(values, dispatch, props);
        logger.logFormSubmission('MortgageCalculator-Step7', values, true);
        return result;
    } catch (error) {
        logger.error('Step 7 form submission failed', {
            step: 7,
            formName: formName,
            values,
            error: error.message || error
        });
        throw error;
    }
};

StepSevenForm = reduxForm({
    form: formName,
    destroyOnUnmount: false,
    validate,
    onSubmit: enhancedOnSubmit,
    redirectPath: `/mortgage${Routes.STEPEIGHT}`,
    tracking: () => trackingEvent(tracking)
}, mapStateToProps, mapDispatchToProps)(StepSevenForm);

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(StepSevenForm));
